module.exports = __webpack_public_path__ + "static/media/Loader.c972afe7.gif";